import script from "./PublicDonorInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicDonorInfo.vue?vue&type=script&setup=true&lang=js"

import "./PublicDonorInfo.vue?vue&type=style&index=0&id=acbbb200&lang=css"

const __exports__ = script;

export default __exports__